<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'comandosCrud'"
          crudName="Comandos"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="false"
          :enableEdit="false"
          :enableDelete="false"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "comandosTable",
      comandosCrud: {},
      pages: [],
      url: "",
      columns: ["id", "device_id", "comando", "status", "resultado", "exit_code", "created_at"],
      tableData: ["id", "device_id", "comando", "status", "resultado", "exit_code", "created_at"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          device_id: "Dispositivo (ID)",
          comando: "Comando",
          status: "Status",
          resultado: "Resultado",
          exit_code: "Exit Code",
          created_at: "Criado em",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "comandos/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        device_id: "device_id",
        comando: "comando",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
